// extracted by mini-css-extract-plugin
export default {"eventsSectionContainer":"EventsSection_eventsSectionContainer__FZrAi","eventsList":"EventsSection_eventsList__J7D0R"};